import { ContactManagementConfigContext } from '../../../../ui/providers';
import { usePublicDataGet } from '@juvare/platform-sdk-react/ui/hooks/usePublicDataGet';
import React from 'react';
export function useAccountSections(page) {
    const { appName } = React.useContext(ContactManagementConfigContext);
    const response = usePublicDataGet('accountSections', appName);
    return Object.assign(Object.assign({}, response), { data: response.data ? response.data.filter((row) => { var _a; return (_a = row.columns.showInPages) === null || _a === void 0 ? void 0 : _a.includes(page); }) : undefined, reload: response.mutate });
}
